import { api } from '../api';
import type { EmailSimilarityReport, Page, User } from '../../types/api';

const ADMIN = '/api/admin';

export const FraudAPI = {
  // Latest persisted similar-email scan (the daily job writes one; empty report if none yet).
  similarEmails: () => api.get<EmailSimilarityReport>(`${ADMIN}/fraud/similar-emails`),
  // Re-run the scan on demand and return the fresh report.
  runScan: () => api.post<EmailSimilarityReport>(`${ADMIN}/fraud/similar-emails/scan`, undefined, { idempotent: true }),
  // Accounts flagged for signing up from an already-seen IP address.
  ipFlagged: (page: number, size = 25) =>
    api.get<Page<User>>(`${ADMIN}/fraud/ip-flagged?page=${page}&size=${size}`),
};
